import { styled, SxProps, Theme } from '@mui/material';
import { ComponentProps } from 'react';
import { MenuItem } from 'helpers/Menu';

export const StyledMenuItem = styled((props: ComponentProps<typeof MenuItem>) => <MenuItem {...props} />)(
  ({ theme }) => ({
    color: theme.palette.secondary.main,
    position: 'relative',
    paddingLeft: 32,
    paddingTop: 8,
    paddingBottom: 8,
    '& .MuiListItemIcon-root': { color: 'inherit' },
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.action.hover,
      span: { color: theme.palette.primary.main }
    }
  })
) as typeof MenuItem;

export const sidebarContainerSx: SxProps<Theme> = {
  bgcolor: 'background',
  width: 264,
  paddingTop: 5,
  flexShrink: 0,
  boxShadow: '4px 0px 10px rgba(111, 111, 111, 0.04);'
};

export const selectItemContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
};

export const formControlSx: SxProps<Theme> = { marginBottom: 4, minWidth: 200, color: 'secondary' };

export const menuListSx: SxProps<Theme> = { width: '100%' };

export const logooutContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexGrow: 1,
  width: '100%',
  alignItems: 'flex-end',
  paddingLeft: 9,
  paddingBottom: 4,
  cursor: 'pointer'
};

export const langSwitchContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexGrow: 8,
  width: '100%',
  justifyContent: 'center',
  alignItems: 'flex-end'
};
